module.exports = __webpack_public_path__ + "static/img/200252.52c4b099.png";